import Vue from 'vue';
import VueRouter from 'vue-router';

import Home from './pages/home';

Vue.use(VueRouter);

const routes = [
  { path: '/', component: Home, name: 'home' },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/routing.js